import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openDialog, closeDialog } from '../../actions/dialog';
import { listAccounts, setSelectedAccount } from '../../actions/superadmin';
import { SUPER_ADMIN } from '../../config/app_config';
import { storeWithExpiration } from '../../utils/common';
import { getPriceBook, getRevShare, updatePrice } from '../../actions/pricing';

import SuperadminPricing from './SuperadminPricing';

export class SuperadminPricingContainer extends React.Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    dialog: PropTypes.object.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    priceBook: PropTypes.object.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    getPriceBookAction: PropTypes.func.isRequired,
    getRevShareAction: PropTypes.func.isRequired,
    listAccountsAction: PropTypes.func.isRequired,
    setSelectedAccountAction: PropTypes.func.isRequired,
    selectedAccount: PropTypes.object,
    updatePriceAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedAccount: undefined,
  };

  state = {
    activeLink: null,
  };

  componentWillMount = () => {
    const { listAccountsAction, getPriceBookAction, getRevShareAction } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      listAccountsAction(token, resolve);
    });
    prom.then(() => {
      this.props.accounts.map(account => getPriceBookAction(account.id, token));

      // Two seperate steps to make sure the pricebook gets retrieved for all accounts prior to
      // making this call
      this.props.accounts.map(account => getRevShareAction(account.id, token));
    });
  };

  componentWillReceiveProps = nextProps => {
    const { accounts, selectedAccount } = nextProps;
    accounts.forEach((account, key) => {
      if (selectedAccount && account.get('id') === selectedAccount.get('id')) {
        this.setState({ activeLink: key });
      }
    });
  };

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(id);
    } else {
      openDialogAction(id);
    }
  };

  cancelDialog = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  handleAccountSelect = (account, key, evt) => {
    evt && evt.preventDefault();
    const { setSelectedAccountAction } = this.props;
    this.setState({ activeLink: key });
    setSelectedAccountAction(account);
  };

  render() {
    const {
      accounts,
      dialog,
      isSuperAdmin,
      priceBook,
      openDialogAction,
      closeDialogAction,
      getPriceBookAction,
      selectedAccount,
      updatePriceAction,
    } = this.props;
    const { activeLink } = this.state;

    return (
      <div>
        <SuperadminPricing
          accounts={accounts}
          activeLink={activeLink}
          dialog={dialog}
          handleAccountSelect={this.handleAccountSelect}
          isSuperAdmin={isSuperAdmin}
          priceBookList={priceBook.get('priceBookList')}
          accountPriceSettings={priceBook.get('initialSettings')}
          getPriceBookAction={getPriceBookAction}
          updatePriceAction={updatePriceAction}
          openDialogFunction={openDialogAction}
          closeDialogFunction={closeDialogAction}
          selectedAccount={selectedAccount}
          toggleDialog={this.toggleDialog}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { dialog, priceBook, superadmin, user } = state;
  const accounts = superadmin.get('accounts');
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const selectedAccount = superadmin.get('selectedAccount');
  return {
    accounts,
    dialog,
    isSuperAdmin,
    priceBook,
    selectedAccount,
  };
}

export default connect(mapStateToProps, {
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  getPriceBookAction: getPriceBook,
  getRevShareAction: getRevShare,
  listAccountsAction: listAccounts,
  setSelectedAccountAction: setSelectedAccount,
  updatePriceAction: updatePrice,
})(SuperadminPricingContainer);
